import React from 'react';
import {
  Button,
  Grid,
  GridColumn,
  GridRow,
  Gutter,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalSection,
  Paragraph,
  SectionHeader,
  useBreakpoint,
  Well,
} from '@axiom/ui';
import type { Account } from '@axiom/validation';

import AddToTeam from '../../public/svg/add_to_team.svg';

export type AccountReassignmentNotificationModalProps = {
  name: string;
  data: { account: Account };
  onClose: () => Promise<void>;
};
export const AccountReassignmentNotificationModal = ({
  name,
  data: { account },
  onClose,
}: {
  name: string;
  data: { account: Account };
  onClose: () => Promise<void>;
}) => {
  const { isMobile } = useBreakpoint();

  return (
    <Modal name={name}>
      <ModalHeader name={`${name}_HEADER`} onClose={async () => onClose()}>
        Account Update
      </ModalHeader>
      <ModalSection>
        <Grid>
          <GridRow gutterBottom="16px">
            <GridColumn textAlign="center">
              <Well background="light blue">
                <AddToTeam width={isMobile ? '100%' : '400'} height="100%" />
              </Well>
            </GridColumn>
          </GridRow>
          <GridRow>
            <GridColumn>
              <SectionHeader name="SECTION_HEADER">
                You've been added to {account.name}'s Axiom account
              </SectionHeader>
              <Gutter bottom="16px" />
              <Paragraph as="p" name="PARAGRAPH">
                It looks like your organization already has an Axiom account so
                we've added you to it. Review all of {account.name}'s current,
                past, and upcoming Axiom engagements or explore more Axiom legal
                talent.
              </Paragraph>
            </GridColumn>
          </GridRow>
        </Grid>
      </ModalSection>
      <ModalFooter>
        <Button name="GOT_IT_BUTTON" onClick={async () => onClose()}>
          Got It!
        </Button>
      </ModalFooter>
    </Modal>
  );
};
